import React, { useState } from "react";
import { TextField, Button, CircularProgress } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
const Login = props => {
  const [state, setState] = useState({
    username: "",
    password: ""
  });
  return (
    <div style={{ textAlign: "center" }}>
      <h1>Shopping Cart Login</h1>
      <p>
        <TextField
          id="outlined-name"
          label="Name"
          margin="normal"
          variant="outlined"
          style={{ backgroundColor: "white" }}
          onChange={event => {
            console.log(state);

            setState({ ...state, username: event.currentTarget.value });
          }}
        />
      </p>
      <p>
        <TextField
          id="outlined-password-input"
          label="Password"
          margin="normal"
          type="password"
          variant="outlined"
          style={{ backgroundColor: "white" }}
          onChange={event => {
            setState({ ...state, password: event.currentTarget.value });
          }}
        />
      </p>
      {props.logged ? (
        <Button
          variant="contained"
          color="primary"
          disabled
          onClick={props.login.bind(null, state.username, state.password)}
        >
          <CircularProgress
            size={24}
            className={{
              color: green[500],
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: -12,
              marginLeft: -12
            }}
          />
          login
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={props.login.bind(null, state.username, state.password)}
        >
          login
        </Button>
      )}
    </div>
  );
};

export default Login;
